module.exports = new __parcel__URL__("starwolvez_bolt_logo.8f9a4c36.png").toString();